export default {"src":"/_next/static/media/questionsIcon.7a1362f7.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};